import React, { useState } from 'react';
import { useForm, router, usePage } from '@inertiajs/react';
import { AffiliateLayout } from '../../../design-system/components/layouts';
import { Card, CardBody, Button, Input } from '../../../design-system/components';
import {
  affiliate_onboarding_update_paypal_path,
  affiliate_onboarding_skip_paypal_path,
} from '../../../lib/routes';

export default function Paypal({ current_paypal_email, step, total_steps }) {
  const { props } = usePage();
  const flash = props.flash;
  const form = useForm({
    paypal_email: current_paypal_email || '',
  });
  const [skipping, setSkipping] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    form.post(affiliate_onboarding_update_paypal_path());
  };

  const handleSkip = () => {
    setSkipping(true);
    router.post(affiliate_onboarding_skip_paypal_path());
  };

  const canSubmit =
    form.data.paypal_email.length > 0 &&
    form.data.paypal_email.includes('@') &&
    !form.processing;

  return (
    <AffiliateLayout>
      <div className="max-w-xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm font-medium text-fg-tertiary mb-2">
            Step {step} of {total_steps}
          </p>
          <h1 className="text-2xl font-semibold text-fg tracking-tight">
            Set your PayPal email
          </h1>
          <p className="mt-2 text-sm text-fg-tertiary">
            This is where we&apos;ll send your commission payouts. You can change it later.
          </p>
        </div>

        {flash?.alert && (
          <div className="mb-6 rounded-lg bg-red-50 border border-red-200 p-4 text-sm text-red-700">
            {flash.alert}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <Card>
            <CardBody>
              <div className="space-y-4">
                <Input
                  label="PayPal email address"
                  name="paypal_email"
                  id="paypal_email"
                  type="email"
                  value={form.data.paypal_email}
                  onChange={(e) => form.setData('paypal_email', e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  helperText="Enter the email address associated with your PayPal account."
                />

                {form.errors.paypal_email && (
                  <p className="text-sm text-red-600">{form.errors.paypal_email}</p>
                )}
              </div>
            </CardBody>
          </Card>

          <div className="mt-8 flex items-center justify-between">
            <Button
              variant="ghost"
              onClick={handleSkip}
              disabled={skipping || form.processing}
            >
              Skip for now
            </Button>
            <Button type="submit" disabled={!canSubmit} loading={form.processing} size="lg">
              Save &amp; Continue
            </Button>
          </div>
        </form>
      </div>
    </AffiliateLayout>
  );
}
